"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_select_1 = require("react-select");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var types_1 = require("types");
var customerActions = require("@caddigital/sok-reducers/lib/actions/modelspace/customer");
var projectActions = require("@caddigital/sok-reducers/lib/actions/modelspace/project");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
require("./modelspace.scss");
var mapStateToProps = function (state) {
    return {
        modelspace: state.modelspace,
        project: state.project.wizard
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    fetchCustomer: function (customerId) {
        return dispatch(customerActions.fetchRequest(customerId));
    },
    clear: function () { return (dispatch(customerActions.clear()), dispatch(projectActions.clear())); },
    search: function (customerId, configurationId, projectId, modelspaceProjectNumber) {
        return dispatch(projectActions.searchRequest({
            customerId: customerId,
            configurationId: configurationId
        }, projectId, modelspaceProjectNumber));
    },
    save: function (projectId, conf) { return dispatch(projectActions.saveRequest(projectId, conf)); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
//#region Types
var statePropsExtractable = (0, types_1.extractReturnType)(exports.mapStateToProps);
var dispatchPropsExtractable = (0, types_1.extractReturnType)(exports.mapDispatchToProps);
//#endregion
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('configurations', 'setConfigurations', []), (0, recompose_1.withState)('selected', 'SetSelectedConfiguration', null), (0, recompose_1.withState)('searchProject', 'SetSearch', ''), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        if (this.props.isOpen) {
            this.props.fetchCustomer(this.props.customer.id);
        }
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.isOpen !== prevProps.isOpen) {
            if (this.props.isOpen) {
                this.props.fetchCustomer(this.props.customer.id);
            }
            else {
                this.props.clear();
            }
        }
        if (this.props.isOpen &&
            this.props.modelspace.project.saveStatus === 'FETCHED' &&
            prevProps.modelspace.project.saveStatus === 'FETCHING') {
            this.props.toggleModal(false);
        }
        if (this.props.modelspace.customer.configurations !==
            prevProps.modelspace.customer.configurations) {
            var configurationsMap_1 = this.props.modelspace.customer.configurations.reduce(function (acc, item) {
                var key = (item.customerId || '').toString();
                acc[key] = acc[key] || [];
                acc[key].push(item);
                return acc;
            }, {});
            var configurations = Object.keys(configurationsMap_1)
                .sort(function (a, b) { return a.localeCompare(b); })
                .map(function (key) { return ({
                label: "".concat((0, translation_1.getLocalization)('modelspace/customerId'), ": ").concat(key),
                options: configurationsMap_1[key]
            }); });
            this.props.setConfigurations(configurations);
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (nextProps.isOpen || this.props.isOpen !== nextProps.isOpen) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
exports.default = enhance(function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(sok_ui_1.RequestStatusBox, { className: 'project-wizard-modal-modelspace-status', status: props.modelspace.project.saveStatus },
            (0, translation_1.getLocalization)("modelspace/status/saving"),
            (0, translation_1.getLocalization)("modelspace/status/saved"),
            (0, translation_1.getLocalization)("modelspace/status/failed")),
        React.createElement(sok_ui_1.Modal, { isOpen: props.isOpen, className: 'project-wizard-modal-modelspace' },
            React.createElement(sok_ui_1.Header, { onClose: function () { return props.toggleModal(false); } }, "Modelspace"),
            React.createElement("form", { onSubmit: function (e) {
                    e.preventDefault();
                } },
                React.createElement(sok_ui_1.Container, null,
                    (props.modelspace.customer.fetchStatus === 'FAILED' ||
                        props.modelspace.project.fetchStatus === 'FAILED') && (React.createElement("div", null,
                        React.createElement(GenericErrorMessage_1.default, { className: 'small' },
                            React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () {
                                    if (props.modelspace.customer.fetchStatus === 'FAILED') {
                                        props.fetchCustomer(props.customer.id);
                                    }
                                    if (props.modelspace.project.fetchStatus === 'FAILED') {
                                        // TODO fetch project data
                                    }
                                } })))),
                    (props.modelspace.customer.fetchStatus === 'FETCHING' ||
                        props.modelspace.project.fetchStatus === 'FETCHING') && (React.createElement("div", { className: 'center' },
                        React.createElement(sok_ui_1.LoadingSpinner, null))),
                    props.modelspace.customer.fetchStatus === 'FETCHED' && (React.createElement("div", { className: 'content' },
                        React.createElement("div", { className: 'modelspace-row' },
                            React.createElement("div", { className: 'column-1' },
                                React.createElement("div", { className: 'customer-name' },
                                    React.createElement("label", { htmlFor: 'customer-name' }, (0, translation_1.getLocalization)('customer/name')),
                                    React.createElement(sok_ui_1.TextInput, { id: 'customer-name', disabled: true, value: props.customer.name }))),
                            React.createElement("div", { className: 'column-2' },
                                React.createElement("div", { className: 'project-name' },
                                    React.createElement("label", { htmlFor: 'project-name' }, (0, translation_1.getLocalization)('project/name')),
                                    React.createElement(sok_ui_1.TextInput, { id: 'project-name', disabled: true })))),
                        React.createElement("div", { className: 'modelspace-row' },
                            React.createElement("div", { className: 'customer-configurations' },
                                React.createElement("label", { htmlFor: 'configuration' }, (0, translation_1.getLocalization)('modelspace/customerConfiguration')),
                                React.createElement(react_select_1.default, { classNamePrefix: 'react-select', id: 'configuration', placeholder: (0, translation_1.getLocalization)('modelspace/selectConfiguration'), menuPlacement: 'auto', getOptionValue: function (opt) { return opt.configurationId; }, getOptionLabel: function (opt) {
                                        return "".concat((0, translation_1.getLocalization)('modelspace/configurationId'), ": ").concat(opt.configurationId);
                                    }, options: props.configurations, onChange: function (e) {
                                        props.SetSelectedConfiguration(e);
                                    } }))),
                        React.createElement("div", { className: 'modelspace-project' },
                            React.createElement("div", { className: 'search-area' },
                                React.createElement("div", null,
                                    React.createElement("label", null, "Project number")),
                                React.createElement("div", null,
                                    React.createElement(sok_ui_1.TextInput, { placeholder: 'Enter project number', value: props.searchProject, onChange: function (_a) {
                                            var value = _a.target.value;
                                            return props.SetSearch(value);
                                        } }),
                                    React.createElement(sok_ui_1.Button, { color: 'green', size: 'large', onClick: function () {
                                            props.search(props.customer.id, props.selected.configurationId, props.project.step1.id, props.searchProject);
                                        } }, (0, translation_1.getLocalization)('global/search')))),
                            React.createElement("div", null,
                                React.createElement("div", null,
                                    React.createElement("label", null, "Project ID from Modelspace")),
                                React.createElement("div", null,
                                    React.createElement(sok_ui_1.TextInput, { disabled: true, placeholder: 'Modelspace project name', value: props.modelspace.project.searchStatus === 'FETCHED' &&
                                            props.modelspace.project.searchResult !== null
                                            ? "".concat(props.modelspace.project.searchResult.name, ": ").concat(props.modelspace.project.searchResult.number)
                                            : '' })))),
                        props.modelspace.project.searchStatus !== 'STANDBY' && (React.createElement("div", { className: 'status-spinner' },
                            React.createElement(sok_ui_1.RequestSpinner, { success: props.modelspace.project.searchStatus === 'FETCHED', isLoading: props.modelspace.project.searchStatus === 'FETCHING' })))))),
                React.createElement(sok_ui_1.Footer, null,
                    React.createElement(sok_ui_1.Button, { disabled: !(props.modelspace.customer.fetchStatus === 'FETCHED') &&
                            !(props.modelspace.project.fetchStatus === 'FETCHED' ||
                                props.modelspace.project.fetchStatus === 'STANDBY') &&
                            !(props.modelspace.project.saveStatus === 'STANDBY') &&
                            !(props.modelspace.project.searchStatus === 'FETCHED'), text: (0, translation_1.getLocalization)('buttons/connect'), color: 'base-green', type: 'submit', onClick: function () {
                            if (props.project.fetchStatus === 'FETCHED' &&
                                props.modelspace.project.searchResult) {
                                props.save(props.project.step1.id, {
                                    configurationId: props.selected.configurationId,
                                    projectId: props.project.step1.id,
                                    modelspaceProjectId: props.modelspace.project.searchResult.number
                                });
                            }
                        } }),
                    React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('buttons/cancel'), color: 'dark-gray', onClick: function () { return props.toggleModal(false); } }))))));
});
